<script>
import { BSkeletonIcon } from "bootstrap-vue";

export default {
  extends: BSkeletonIcon
};
</script>